import { render, staticRenderFns } from "./xx.vue?vue&type=template&id=0df8114b&scoped=true"
import script from "./xx.vue?vue&type=script&lang=js"
export * from "./xx.vue?vue&type=script&lang=js"
import style0 from "./xx.vue?vue&type=style&index=0&id=0df8114b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8114b",
  null
  
)

export default component.exports